import React from 'react';
import VisionMissionCard from './VisionMissionCard';

const visionMissionData = [
  {
    image: "https://images.pexels.com/photos/4715450/pexels-photo-4715450.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "Vision",
    description: "To build a globally connected creative ecosystem that nurtures talent, encourages collaboration, and showcases the limitless potential of the creative mind across disciplines and cultures.",
    delay: "100ms"
  },
  {
    image: "https://images.pexels.com/photos/6860486/pexels-photo-6860486.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "Mission",
    description: "Through mentorship, collaboration, learning programs, and exposure opportunities, we aim to elevate the creative voice across Africa and the world.",
    delay: "200ms"
  }
];

const VisionMissionSection = () => {
  return (
    <section className="delivering-it" id="vision-mission">
      <div className="container">
        <div className="delivering-it__top">
          <div className="row">
            <div className="col-xl-7 col-lg-7">
              <div className="delivering-it__top-left">
                <div className="section-title text-left">
                  <div className="section-title__tagline-box">
                    <span className="section-title__tagline">Our Purpose</span>
                    <div className="section-title-shape">
                      <img src="assets/images/shapes/section-title-shape.png" alt="decorative shape" />
                    </div>
                  </div>
                  <h2 className="section-title__title">Our Vision & Mission</h2>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5">
              <div className="delivering-it__top-right">
                <p className="delivering-it__top-text">Create & Commune (C2) exists to provide a vibrant space for creatives of all kinds to connect, grow, and create together.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="delivering-it__bottom">
          <div className="row">
            {visionMissionData.map((item, index) => (
              <VisionMissionCard
                key={index}
                image={item.image}
                title={item.title}
                description={item.description}
                delay={item.delay}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMissionSection;
